import { FC } from "react";
import { Link, Button, Image } from "capitalrx-components-2.0/lib/general";
import { Grid, useResponsive } from "capitalrx-components-2.0/lib/layout";
import { Paragraph } from "capitalrx-components-2.0/lib/typography";
import CardSection from "./CardSection";
import WomanSmilingImage from "@/static/images/image-woman-card-min.png";

import styles from "./YouDeserveABetterRX.module.scss";

const ReadMore: FC = () => {
  return (
    <section className={styles.sectionReadMoreBg} data-testid="read_more_section">
      <div className={styles.sectionReadMore}>
        <div className={styles.sectionReadMoreTextContainer}>
          <div className={styles.sectionReadMoreText}>Read more about the Capital Rx Advantage</div>
        </div>
        <Link
          to="https://www.forbes.com/sites/alexknapp/2021/08/11/this-companyaims-to-bring-down-the-cost-of-your-medicine-with-price-transparency/?sh=31c464cf5e86"
          className={styles.sectionViewArticleLink}
        >
          <Button>View Article</Button>
        </Link>
      </div>
    </section>
  );
};

const YouDeserveABetterRX: React.FC = () => {
  const { columns7712, columns5512 } = useResponsive({
    columns7712: {
      desktop: 7,
      tablet: 7,
      mobile: 12,
    },
    columns5512: {
      desktop: 5,
      tablet: 5,
      mobile: 12,
    },
  });
  return (
    <>
      <section className={styles.YouDeserve} data-testid="you-deserve-section">
        <div className={styles.YouDeserveWrapper}>
          <Grid className={styles.YouDeserveGridContainer}>
            <Grid.Spread columns={columns7712}>
              <div className={styles.YouDeserveTextWrapper}>
                <Paragraph className={styles.YouDeserveTextTitle}>You deserve a better Rx</Paragraph>
                <Paragraph className={styles.paragraphOne}>
                  Traditional discount card programs charge high, hidden fees and artificially inflate the cost of your drugs, without any
                  accountability.
                </Paragraph>
                <Paragraph className={styles.paragraphTwo}>
                  <span>We&apos;re here to change that.</span> Capital Rx is proud to bring you a discount card with lower fees and higher
                  potential savings.
                </Paragraph>
              </div>
            </Grid.Spread>
            <Grid.Spread columns={columns5512}>
              <div className={styles.womanSmiling}>
                <Image src={WomanSmilingImage} alt="woman smiling" className={styles.imageWoman} aria-hidden="true" />
              </div>
            </Grid.Spread>
          </Grid>
        </div>

        <CardSection />
      </section>
      <ReadMore />
    </>
  );
};

export default YouDeserveABetterRX;
